

const getModalFromConfigsByModalType = (modalsList, modalType) => {
    const container = modalsList.find(c => {
        return c.modals.filter(m => m.modalType === modalType).length > 0;
    });
    return container ?
        container.modals.find(m => m.modalType === modalType) : {};
};

const getContainerNameByModalType = (modalsList, modalType) => {
    const container = modalsList.find(c => c.modals.find(m => m.modalType === modalType));
    return container ? container.containerName : null;
};

const boundAnchor = anchor => {
    return input => anchor.current = input;
};

export const modalTools = {
    boundAnchor,
    getModalFromConfigsByModalType,
    getContainerNameByModalType
};
